import axios from 'axios'
// import he from 'he';
// import json2csv from 'json2csv';

import apiPath from 'apiPath'
import moment from 'components/momentWithZone'

let loadFieldPrograms = (voyage, reportProgress) => {
	const wordpressVoyageID =
		voyage === '35'
			? 555568747
			: voyage === '36'
			? 555568752
			: voyage === '39'
			? 555574076
			: voyage === '38'
			? 555574483
			: voyage === '40'
			? 555590904
			: 555590904
	return new Promise((resolve, reject) => {
		axios
			.get(
				apiPath + '/fieldprograms/metadata_voyage/' + wordpressVoyageID
			)
			.then((response) => {
				const data = response.data.map((program) => {
					program.trip_code = program.acf.resco_trip_code
						? program.acf.resco_trip_code
						: program.acf.trip_number +
						  '-' +
						  program.acf.section_number

					//delete program.acf;//advance custom fields from wordpress
					delete program.content
					delete program.date
					delete program.date_gmt
					delete program.excerpt
					delete program.featured_media
					delete program.guid
					delete program.id
					delete program.link
					delete program.menu_order
					delete program.modified
					delete program.modified_gmt
					delete program.slug
					delete program.status
					//delete program.title;
					//delete program.trip_types;
					delete program.type
					delete program.voyage_details
					delete program.yoast_head
					delete program._links

					//program.title = {rendered: "this comes from resco."};
					program.acf.short_description_2 =
						'Will need to replace this description with Summary from table'
					program.mainImage =
						'https://www.planetware.com/wpimages/2019/12/hawaii-in-pictures-beautiful-places-to-photograph-hanauma-bay-oahu.jpg'

					return program
				})

				sessionStorage.setItem('fieldProgramsForVoyage', voyage)
				sessionStorage.setItem('fieldPrograms', JSON.stringify(data))
				sessionStorage.setItem('fieldProgramsUpdated', moment().unix())
				resolve()
			})
			.catch(reject)
	})
}

module.exports = loadFieldPrograms



// WEBPACK FOOTER //
// ./portal-components/Portal/FieldPrograms/loadFieldPrograms.js